import * as yup from 'yup'

const schema = yup.object().shape({
  contractIdentifier: yup.string().required(),
  typeService: yup.string().required().typeError('Escolha um tipo de serviço'),
  vertical: yup.string().required().typeError('Escolha uma vertical'),
  generateContract: yup.boolean(),
  clientEmail: yup.string().when('generateContract', {
    is: true,
    then: yup.string().required(),
  }),
  periodOnMonth: yup
    .number()
    .min(1)
    .max(60)
    .required()
    .typeError('Escolha um período'),
  indexType: yup.string().required().typeError('Escolha um índice de reajuste'),
  countCompanyInLimit: yup.number().when('responsibleInLimit', {
    is: true,
    then: yup
      .number()
      .min(1)
      .required()
      .typeError('O número minimo de empresas é 1'),
    otherwise: yup
      .number()
      .min(0)
      .required()
      .typeError('O número minimo de empresas é 0'),
  }),
  responsibleInLimit: yup.boolean(),
  fidelity: yup.boolean(),
  fidelityEndDate: yup
    .string()
    .nullable()
    .when('fidelity', {
      is: true,
      then: yup
        .string()
        .nullable()
        .required('Data de término da fidelidade é obrigatória')
        .typeError('Data de término da fidelidade é obrigatória'),
    }),
})

export default schema
